//window.token = "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwczovL2FkbWluLnBsb3R0ZXJib3guY29tL2FwaS91c2VyL2xvZ2luIiwiaWF0IjoxNjUxNzQwMTYxLCJuYmYiOjE2NTE3NDAxNjEsImp0aSI6Im9jU2tuTDdNbzdqMkMwY28iLCJzdWIiOiIzNiIsInBydiI6IjIzYmQ1Yzg5NDlmNjAwYWRiMzllNzAxYzQwMDg3MmRiN2E1OTc2ZjcifQ.Ht1pAE-CFIAx_BTnCBMUxZ-YgYCz5NBjSRdmpbhY8hc";
//window.token = "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwOlwvXC9lLWJvb2stYXBwLmhlcm9rdWFwcC5jb21cL2FwaVwvdXNlclwvbG9naW4iLCJpYXQiOjE2NDQ5OTkzODQsIm5iZiI6MTY0NDk5OTM4NCwianRpIjoiM1Y4TFc5VThsSVFZMmJPTCIsInN1YiI6MSwicHJ2IjoiMjNiZDVjODk0OWY2MDBhZGIzOWU3MDFjNDAwODcyZGI3YTU5NzZmNyJ9.lu_zYsXo_PiWHVvYqYW3BFW3Zz0WU7NaxEKF3loKruU";
//Staging Token
// window.token = "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwOlwvXC9lLWJvb2stYXBwLWRldmVsb3BtZW50Lmhlcm9rdWFwcC5jb21cL2FwaVwvdXNlclwvcmVnaXN0ZXIiLCJpYXQiOjE2NDUwODA5OTUsIm5iZiI6MTY0NTA4MDk5NSwianRpIjoidWZYMFU0WjBVVERIdU1MeSIsInN1YiI6NCwicHJ2IjoiMjNiZDVjODk0OWY2MDBhZGIzOWU3MDFjNDAwODcyZGI3YTU5NzZmNyJ9.ydXgjf2N8oMsWZ8vCXjbeXx4_6d8ypakucCnblC9R-Y";
//Development Token
// window.token = "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwOi8vcGxvdHRlcmJveC1hZG1pbi5kZXZlbG9wbWVudC5zYW5kYm94LmZsb3RpbGxhdGVjaHMuY29tL2FwaS91c2VyL2xvZ2luIiwiaWF0IjoxNjUzNzE2ODkzLCJuYmYiOjE2NTM3MTY4OTMsImp0aSI6IjZmRnZqYUhrVVk5NXBpQzkiLCJzdWIiOiI0IiwicHJ2IjoiMjNiZDVjODk0OWY2MDBhZGIzOWU3MDFjNDAwODcyZGI3YTU5NzZmNyJ9.HJ70CkH_OGm7qVRQZ-ULWL8CuEl15HuusykjzlZgSVg";
import axios from "axios";
import env from "./config.js";
window.axios = axios;

//console.log({ ENV: env });
const token = localStorage.getItem("token");
window.STATIC_TOKEN = env.STATIC_TOKEN;
window.token = token || env.STATIC_TOKEN;
// PayPal: sandbox everywhere except production (IDs in config.js)
window.PAYPAL_CLIENT_ID = env.PAYPAL_SANDBOX_CLIENT_ID;
if (env?.PRODUCTION_URL.split(",").includes(window.location.origin)) {
  window.PAYPAL_CLIENT_ID = env.PAYPAL_LIVE_CLIENT_ID;
  window.base = "https://admin.plotterbox.com";
  window.UPLOADHANDPRINT = "https://handprint.plotterbox.com/uploadImage";
  window.wocommerce = "https://ordercommerce.plotterbox.com";
  window.token = token || env.STATIC_TOKEN;
} else if (env?.STAGING_URL.split(",").includes(window.location.origin)) {
  window.base = "https://staging-admin.plotterbox.com";
  window.UPLOADHANDPRINT =
    "https://staging-handprint.plotterbox.com/uploadImage";
  window.wocommerce = "https://staging-ordercommerce.plotterbox.com";
  window.token = token || env.STATIC_TOKEN;
} else if (env?.DEVELOPMENT_URL.split(",").includes(window.location.origin)) {
  window.base = "https://staging-admin.plotterbox.com";
  window.UPLOADHANDPRINT =
    "https://staging-handprint.plotterbox.com/uploadImage";
  window.wocommerce = "https://staging-ordercommerce.plotterbox.com";
  window.token = token || env.STATIC_TOKEN;
} else {
  // Local Vite dev server (localhost:3000): call the staging backend
  // directly. It only allows CORS for that exact origin — any other
  // local port needs vite.config.js's /api proxy instead (browsers won't
  // permit a direct cross-origin call the backend doesn't allow).
  window.base = env.LOCAL_BASEURL;
  window.UPLOADHANDPRINT = env.LOCAL_UPLOADHANDPRINT;
  window.token = token || env.STATIC_TOKEN;
  window.wocommerce = env.LOCAL_WOOCOMMERCE;
}
if (!token && window.token) {
  localStorage.setItem("token", window.token);
}

// A stale/invalid token makes every in-flight request 401 at once (they're
// all fired on page load in parallel), which used to surface as one alert
// per failed call. Handle it once: clear storage and hard-reload so the app
// comes back up logged out, instead of piling up duplicate error alerts.
let sessionExpiredHandled = false;
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401) {
      if (!sessionExpiredHandled) {
        sessionExpiredHandled = true;
        localStorage.clear();
        window.location.reload();
      }
      // Swallow the rest — every other request racing to 401 right now
      // would otherwise still reach its own .catch()/alert before the
      // reload actually takes effect.
      return new Promise(() => {});
    }
    return Promise.reject(error);
  }
);

const defaultText = "";

// One loader shared by all in-flight requests. Pages that fire several
// API calls (in parallel or back to back) would otherwise open and close
// a loader per call, making it blink. The short close delay lets a
// follow-up request reuse the loader that is already on screen.
const LOADER_CLOSE_DELAY = 250;
const sharedLoader = { count: 0, modal: null, closeTimer: null };

const acquireSharedLoader = () => {
  clearTimeout(sharedLoader.closeTimer);
  if (!sharedLoader.modal) {
    sharedLoader.modal = loader(defaultText);
  }
  sharedLoader.count++;
  let released = false;
  return {
    close: () => {
      if (released) return;
      released = true;
      sharedLoader.count = Math.max(0, sharedLoader.count - 1);
      if (sharedLoader.count === 0) {
        sharedLoader.closeTimer = setTimeout(() => {
          if (sharedLoader.count === 0 && sharedLoader.modal) {
            sharedLoader.modal.close();
            sharedLoader.modal = null;
          }
        }, LOADER_CLOSE_DELAY);
      }
    },
  };
};

export default {
  handelAlert: (func, loaderSet = true, message = "") => {
    return new Promise((res, rej) => {
      let loadObj = { close: () => {} };
      if (loaderSet && window.loader) {
        // A custom message gets its own loader so the text isn't lost
        loadObj = message ? loader(message) : acquireSharedLoader();
      }
      let customRej = (...arg) => {
        loadObj.close();
        let [error] = arg;
        if (error && error.response && error.response.data) {
          let errorMessages = error.response.data.errorMessages || [];
          //console.log({ rejected: errorMessages.map((o) => o.errorMessage) });
          let message = errorMessages.map((o) => o.errorMessage || o).join(",");
          if (message) {
            alert(message);
          }
        }
        rej(...arg);
      };
      let customResolve = (...arg) => {
        loadObj.close(), res(...arg);
      };
      func(customResolve, customRej, loadObj);
    });
  },
};
